import { render, staticRenderFns } from "./ConfettiBackground.vue?vue&type=template&id=39bb3cf1&scoped=true&"
import script from "./ConfettiBackground.vue?vue&type=script&lang=js&"
export * from "./ConfettiBackground.vue?vue&type=script&lang=js&"
import style0 from "./ConfettiBackground.vue?vue&type=style&index=0&id=39bb3cf1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb3cf1",
  null
  
)

export default component.exports